<footer class="footer">
    <div class="container">
        <h1>footer content here.</h1>
    </div>
</footer>